import { Container, Title, Text, Grid, Paper, TextInput, Select, Input, Textarea, FileInput, Button, Group } from "@mantine/core";
import Topnavbar from "../../../Layouts/Topnavbar";
import { DatePicker, message } from "antd";
import { Table } from 'antd';
import RequestHistorydist from "./Topinhistory";
import dayjs from "dayjs";
import { useState, useEffect } from "react";
import { Admin_Banks_get, User_Topin_Request } from "../../../apicall";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";







const columns = [
    {
        title: "S.No.",
        width: 60,
        align: "center",
        render: (_, __, index) => index + 1,
    },
    {
        title: "Bank Name",
        dataIndex: "BankName",
        width: 120,
        render: (code) => <Text copyable>{code}</Text>,
    },
    {
        title: "Bank IFSC",
        dataIndex: "BankIfsc",
        width: 180,
    },
    {
        title: "Bank Holder Name",
        dataIndex: "BankHolder",
        width: 220,
    },
    {
        title: "Account Number",
        dataIndex: "BankAccountNumber",
        width: 120,
        // render: (type) => (
        //     <Tag color={type === "Retailer" ? "blue" : "purple"}>
        //         {type}
        //     </Tag>
        // ),
    },
    {
        title: "Bank Branch",
        dataIndex: "BankBranch",
        width: 130,
        //render: (mobile) => <Text copyable>{mobile}</Text>,
    },
];


const Topinrequestdist = ({ Headername }) => {
    const { user } = Userauthcontexthooks();
    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({
        depositeType: "",
        depositeDate: null,
        amount: "",
        bank: "",
        accountNumber: "",
        ifscCode: "",
        utr: "",
        remarks: "",
        uploadSlip: null,
    });
    const [fetchbanksLoading, setFetchbanksLoading] = useState(true);
    const [Bankslists, setbankslists] = useState([]);

    const isAdvanceCredit = form.depositeType === "Advance Credit";

    const handleBankChange = (value) => {
        const bank = Bankslists.find((b) => b._id === value);

        setForm((prev) => ({
            ...prev,
            bank: value,
            accountNumber: bank?.BankAccountNumber || "",
            ifscCode: bank?.BankIfsc || "",
        }));
    };

    const handleSubmit = async () => {
        if (!form.depositeType) {
            return message.error("Select deposit type");
        }

        if (!form.depositeDate) {
            return message.error("Select deposit date");
        }

        if (!form.amount) {
            return message.error("Enter amount");
        }

        if (!isAdvanceCredit) {
            if (!form.bank) {
                return message.error("Select bank");
            }

            if (!form.utr) {
                return message.error("Enter UTR number");
            }
        }
        const body = {
            depositeType: form.depositeType,
            depositeDate: dayjs(form.depositeDate).format("YYYY-MM-DD"),
            amount: form.amount,
            accountNumber: form.accountNumber,
            ifscCode: form.ifscCode,
            utr: form.utr,
            remarks: form.remarks,
        };
        // const body = new FormData();

        // body.append("depositeType", form.depositeType);
        // body.append(
        //     "depositeDate",
        //     dayjs(form.depositeDate).format("YYYY-MM-DD")
        // );
        // body.append("amount", form.amount);
        // body.append("remarks", form.remarks);

        // if (!isAdvanceCredit) {
        //     body.append("accountNumber", form.accountNumber);
        //     body.append("ifscCode", form.ifscCode);
        //     body.append("utr", form.utr);
        // }

        // if (form.uploadSlip) {
        //     body.append("uploadSlip", form.uploadSlip);
        // }

        // console.log([...body.entries()]);

        // API Call
        try {
            setLoading(true);
            const data = await User_Topin_Request(body);
            if (data.success) {
                message.success(data?.message || "Request submitted successfully.");
                // Reset form after successful submission
                setForm({
                    depositeType: "",
                    depositeDate: null,
                    amount: "",
                    bank: "",
                    accountNumber: "",
                    ifscCode: "",
                    utr: "",
                    remarks: "",
                    uploadSlip: null,
                });
            }
        } catch (error) {
            console.log(error);

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setLoading(false);
        }
    };

    const bankOptions = Bankslists.map((bank) => ({
        value: bank._id,
        label: bank.BankName.trim(),
    }));

    useEffect(() => {
        const fetchAdminBanks = async () => {
            try {
                const data = await Admin_Banks_get();
                if (data.success) {
                    //console.log(data);
                    setbankslists(data?.AdminBanks);
                    // setFilteredbankslists(data?.AdminBanks);
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setFetchbanksLoading(false);
            }
        }

        if (user) {
            fetchAdminBanks();
        }

    }, [user])
    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Top In Request</Title>
                <Text size="xs">Wallet top up, Admin Banks & Top in histories</Text>
            </Container>

            <Container size="lg" mt="lg">
                <Grid>
                    <Grid.Col span={{ xs: 12, sm: 12, md: 4 }}>
                        <Paper shadow="xs" radius="sm" p="sm">
                            <Select
                                label="Deposit Type"
                                placeholder="Select"
                                withAsterisk
                                size="md" mt={'xs'}
                                value={form.depositeType}
                                data={[
                                    "Branch Deposit",
                                    "CDM Deposit",
                                    "Online",
                                    "Cash By Hand",
                                    "Advance Credit",
                                ]}
                                onChange={(value) =>
                                    setForm((prev) => ({
                                        ...prev,
                                        depositeType: value,
                                        bank: "",
                                        accountNumber: "",
                                        ifscCode: "",
                                        utr: "",
                                    }))
                                }
                            />

                            <Input.Wrapper
                                label="Deposit Date"
                                withAsterisk
                                size="md" mt={'xs'}
                            >
                                <DatePicker
                                    value={form.depositeDate}
                                    onChange={(value) =>
                                        setForm((prev) => ({
                                            ...prev,
                                            depositeDate: value,
                                        }))
                                    }
                                    style={{ width: "100%", marginTop: 8 }}
                                />
                            </Input.Wrapper>

                            <TextInput
                                size="md" mt={'xs'}
                                label="Amount"
                                withAsterisk
                                value={form.amount}
                                onChange={(e) =>
                                    setForm((prev) => ({
                                        ...prev,
                                        amount: e.target.value,
                                    }))
                                }
                            />

                            {/* Hide Bank Details for Advance Credit */}

                            {!isAdvanceCredit && (
                                <>
                                    <Select
                                        size="md" mt={'xs'}
                                        label="Bank"
                                        withAsterisk
                                        placeholder="Select Bank"
                                        data={bankOptions}
                                        value={form.bank}
                                        onChange={handleBankChange}
                                        loading={fetchbanksLoading}
                                    />
                                    {
                                        form.bank !== '' && (<Group justify="flex-start">
                                            <TextInput
                                                size="xs"
                                                label="Selected Bank Account Number"
                                                value={form.accountNumber}
                                                readOnly
                                            />

                                            <TextInput
                                                size="xs"
                                                label="IFSC Code"
                                                value={form.ifscCode}
                                                readOnly
                                            />
                                        </Group>
                                        )
                                    }


                                    <TextInput
                                        size="md" mt={'xs'}
                                        label="UTR Number"
                                        withAsterisk
                                        value={form.utr}
                                        onChange={(e) =>
                                            setForm((prev) => ({
                                                ...prev,
                                                utr: e.target.value,
                                            }))
                                        }
                                    />
                                </>
                            )}

                            <Textarea
                                size="md" mt={'xs'}
                                label="Remarks"
                                value={form.remarks}
                                onChange={(e) =>
                                    setForm((prev) => ({
                                        ...prev,
                                        remarks: e.target.value,
                                    }))
                                }
                            />

                            <FileInput
                                size="md" mt={'xs'}
                                label="Upload Slip"
                                placeholder="Choose file"
                                value={form.uploadSlip}
                                onChange={(file) =>
                                    setForm((prev) => ({
                                        ...prev,
                                        uploadSlip: file,
                                    }))
                                }
                            />

                            <Button
                                // type="primary"
                                loading={loading}
                                fullWidth mt={'md'}
                                size="md"
                                variant="light"
                                onClick={handleSubmit}
                            >
                                Submit Request
                            </Button>
                        </Paper>
                        {/* <Paper shadow="xs" radius={'sm'} p={'sm'}>
                            <Select label="Deposite Type" withAsterisk size="md" data={['Branch Deposit', 'CDM Desposit', 'Online', 'Cash By Hand', 'Advance Credit']} placeholder="Select" />
                            <Input.Wrapper label="Deposite Date" withAsterisk size="md" mt={'xs'}>
                                <DatePicker style={{ width: '100%', marginTop: '10px' }} placeholder="Select Date" />
                            </Input.Wrapper>
                            <TextInput label="Amount" placeholder="Amount" size="md" withAsterisk mt={'xs'} />
                            <Select label="Bank" withAsterisk size="md" data={['PNB', 'SBI', 'Axis', 'IDFC']} placeholder="Select" mt={'xs'} />
                            <TextInput label="Selected Bank Account Number" placeholder="Account Number" size="md" mt={'xs'} disabled />
                            <TextInput label="UTR Number" placeholder="UTR" size="md" withAsterisk mt={'xs'} />
                            <Textarea label="Remark (Optional)" placeholder="Remark" size="md" mt={'xs'} />
                            <FileInput label="Upload Slip (Optional)" placeholder="Upload Slip" size="md" mt={'xs'} />

                            <Button fullWidth mt={'md'} size="md" variant="light">Submit</Button>
                        </Paper> */}
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 12, md: 8 }}>
                        <Paper shadow="xs" radius={'sm'} p={'sm'}>
                            <Title order={4} c={'dimmed'}>Top In Admin Banks</Title>
                            <Text size="xs">Verify bank details</Text>
                            <Table
                                columns={columns}
                                dataSource={Bankslists}
                                loading={fetchbanksLoading}
                                bordered
                                size="middle"
                                rowKey="_id"
                                pagination={{
                                    pageSize: 10,
                                    showSizeChanger: true,
                                }} />
                        </Paper>
                    </Grid.Col>
                </Grid>
            </Container>

            <Container size="lg" mt="lg">
                <Paper shadow="xs" radius={'sm'} p={'sm'}>
                    <Title order={4} c={'dimmed'}>Top In Histories</Title>
                    <Text size="xs" mb={'xs'}>View your top in request history</Text>
                    <RequestHistorydist />
                </Paper>
            </Container>
        </>
    )
}
export default Topinrequestdist;